import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// App Firebase phụ, dùng riêng để admin tạo tài khoản cho người khác:
// createUserWithEmailAndPassword tự đăng nhập luôn vào user vừa tạo trên
// instance auth mà nó chạy, nên phải chạy trên 1 app riêng để không làm mất
// phiên đăng nhập của admin trên app chính.
export function layAppTaoTaiKhoan() {
  const ten = "tao-tai-khoan";
  return getApps().find((a) => a.name === ten) ?? initializeApp(firebaseConfig, ten);
}
